import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { BACKEND_BASE_URL } from "../../../apiInstances/baseurl";
import ag1 from "../../../assets/ag1.png";
import GeneralEnquiry from "./GeneralEnquiry";

const ContactCard = ({ AgencyData }) => {
  const [whichActive, setWhichActive] = useState("Selling a property");
  const [Next, setNext] = useState(true);

  const ActiveTab = "!border !text-[#FFFFFF] !bg-[#E5002A] !border-[#E5002A]";

  return (
    <div className="flex flex-col justify-between bg-white rounded-xl shadow-md hover:shadow-lg cursor-pointer">
      {/* ------ Profile ------ */}
      <div className="flex flex-col justify-center items-center">
        <div
          className={`w-full grid place-items-center py-3 rounded-t-xl bg-[#FFE512]`}
        >
          <LazyLoadImage
            src={`${BACKEND_BASE_URL}${AgencyData?.agencySmallLogo}`}
            alt=""
            srcSet={`${BACKEND_BASE_URL}${AgencyData?.agencySmallLogo}`}
            loading="lazy"
            effect="blur"
            className="h-10 rounded-lg"
          />
        </div>
        <div className="flex flex-col justify-center items-center pt-4 md:pt-6 px-4 md:px-6">
          <div className="text-[#171717] text-center font-bold text-base md:text-lg lg:text-xl">
            {AgencyData?.principal_name}
          </div>

          {/* ------ Ratings ------ */}
          <div className="flex justify-center items-center mt-4">
            <svg
              aria-hidden="true"
              className="w-5 h-5 hover:text-gray-300 text-yellow-400"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>First star</title>
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
            </svg>
            <svg
              aria-hidden="true"
              className="w-5 h-5 hover:text-gray-300 text-yellow-400"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Second star</title>
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
            </svg>
            <svg
              aria-hidden="true"
              className="w-5 h-5 hover:text-gray-300 text-yellow-400"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Third star</title>
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
            </svg>
            <svg
              aria-hidden="true"
              className="w-5 h-5 hover:text-gray-300 text-yellow-400"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Fourth star</title>
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
            </svg>
            <svg
              aria-hidden="true"
              className="w-5 h-5 hover:text-gray-300 text-yellow-400"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Fifth star</title>
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
            </svg>
          </div>
          <div className="text-[#A3A3A3] text-center font-medium text-xs mt-1">
            5.0 (482 review)
          </div>
        </div>
      </div>
      {/* ------ Buttons ------ */}
      {Next ? (
        <div className="w-full p-4 md:p-6">
          <div className="flex flex-col justify-start items-start gap-3 mt-5 md:mt-10">
            <div className="text-[#404040] text-center font-semibold text-sm md:text-base lg:text-lg">
              What’s your enquiry about?
            </div>

            <div className="w-full flex flex-col justify-center items-center gap-3">
              <div className="w-full flex flex-col md:flex-row justify-center items-center gap-3">
                <button
                  className={`w-full flex justify-center items-center text-xs md:text-sm lg:text-base font-medium border border-[#737373] text-[#737373] hover:bg-[#FFFFFF] py-3 px-5 rounded-3xl ${
                    whichActive === "Selling a property" ? ActiveTab : null
                  }`}
                  onClick={() => setWhichActive("Selling a property")}
                >
                  Selling a property
                </button>
                <button
                  className={`w-full flex justify-center items-center text-xs md:text-sm lg:text-base font-medium border border-[#737373] text-[#737373] hover:bg-[#FFFFFF] py-3 px-5 rounded-3xl ${
                    whichActive === "An advertised property" ? ActiveTab : null
                  }`}
                  onClick={() => setWhichActive("An advertised property")}
                >
                  An advertised property
                </button>
              </div>
              <div className="w-full flex flex-col md:flex-row justify-center items-center gap-3">
                <button
                  className={`w-full flex justify-center items-center text-xs md:text-sm lg:text-base font-medium border border-[#737373] text-[#737373] hover:bg-[#FFFFFF] py-3 px-5 rounded-3xl ${
                    whichActive === "Property management" ? ActiveTab : null
                  }`}
                  onClick={() => setWhichActive("Property management")}
                >
                  Property management
                </button>
                <button
                  className={`w-full flex justify-center items-center text-xs md:text-sm lg:text-base font-medium border border-[#737373] text-[#737373] hover:bg-[#FFFFFF] py-3 px-5 rounded-3xl ${
                    whichActive === "General enquiry" ? ActiveTab : null
                  }`}
                  onClick={() => setWhichActive("General enquiry")}
                >
                  General enquiry
                </button>
              </div>
            </div>

            <div className="w-full flex justify-center items-center mt-5 md:mt-10">
              <button
                className="w-full flex justify-center items-center text-xs md:text-sm lg:text-base font-medium border text-[#FFFFFF] bg-[#E5002A] border-[#E5002A] hover:text-[#E5002A] hover:bg-[#FFFFFF] hover:font-semibold py-3 px-5 rounded-3xl"
                onClick={() => setNext(false)}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <GeneralEnquiry
            setNext={setNext}
            whichActive={whichActive}
            data={AgencyData}
          />
        </div>
      )}
    </div>
  );
};

export default ContactCard;
